import type { FaireProductEntity } from "../../entity_types/product";

export const p_nmuedqcd9y: FaireProductEntity = {
  token: "p_nmuedqcd9y",
  type: "product",
  name: "Cece Body Butter",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/01b4e1c98c01cfb838b1147cce6c199f3fbe1247e7f0620cea4220e5bb7923d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cda2139c7a222abcfab54cf985efbd7444967f8820f4dae0b3d08fd6e303168.jpeg",
    "https://cdn.faire.com/fastly/38513f54199f0891fc74be19f3c017bafc215484325364abc7937339f3cd0058.jpeg",
    "https://cdn.faire.com/fastly/5935d144282221dacca1d987a5233ea06bc19c6cd05d783f3cee994f84cf1bf3.jpeg",
  ],
  priceDollars: 30.8,
  description:
    "Pamper your skin with Homecourt’s Cece Body Butter, a rich, velvety cream formulated for intense hydration and infused with our iconic fine fragrance. Designed to deliver deep nourishment and long-lasting moisture, this moisturizing body cream leaves skin smooth, supple, and beautifully scented.\n\nCrafted with skincare-grade ingredients, this luxury body butter combines powerful botanicals with indulgent texture for a treatment that hydrates instantly and lasts up to 72 hours.\n\n𝐖𝐡𝐲 𝐘𝐨𝐮’𝐥𝐥 𝐋𝐨𝐯𝐞 𝐈𝐭\n•Luxury body butter infused with Homecourt’s signature fine fragrance\n•Shea butter to deeply moisturize and condition skin\n•Organic rosella extract for 72-hour hydration\n•Plant-sourced vitamin E delivers antioxidant protection\n•Natural clay minerals leave skin soft and supple\n•Upcycled sugar beet extract provides sustainable, natural moisture\n•Hydrating body cream with a fast-absorbing, non-greasy finish\n\nCece\nCedarwood smoke, cardamom, cinnamon, and white leather. Grounded, mysterious, addictive.\nNotes: Cardamom*, Mate Leaves*, Cinnamon*, Carrot Seed, Patchouli*, Vetiver*\n\n𝐇𝐨𝐰 𝐭𝐨 𝐔𝐬𝐞\n\nMassage onto clean, dry skin until fully absorbed. Use daily for luxurious hydration and lasting fragrance.\n\n𝐒𝐢𝐳𝐞\n\n6.7 fl oz / 200 ml\n\n𝐏𝐚𝐢𝐫𝐢𝐧𝐠 𝐑𝐞𝐜𝐨𝐦𝐦𝐞𝐧𝐝𝐚𝐭𝐢𝐨𝐧\n\nLayer with Homecourt’s Cece Body Wash and Body Mist for a complete luxury body care ritual that hydrates, scents, and refreshes from head to toe.",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:21.731Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
